import { render, staticRenderFns } from "./BaseFiltroPonto.vue?vue&type=template&id=0ca93fe6"
import script from "./BaseFiltroPonto.vue?vue&type=script&lang=js"
export * from "./BaseFiltroPonto.vue?vue&type=script&lang=js"
import style0 from "./BaseFiltroPonto.vue?vue&type=style&index=0&id=0ca93fe6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports